// Shared constants and helpers for the medications module.

export const VIAS = [
  "Oral",
  "Gastrostomia (PEG)",
  "Sublingual",
  "Subcutanea (SC)",
  "Intramuscular (IM)",
  "Intravenosa (IV)",
  "Topica",
  "Rectal",
  "Inhalada",
  "Oftalmica",
  "Otica",
  "Nasal",
  "Otra",
];

export const INDICATIONS = [
  { value: "rx", label: "Indicacion medica", short: "Rx" },
  { value: "prn", label: "Razon necesaria (PRN)", short: "PRN" },
];

export function indicationLabel(v) {
  return INDICATIONS.find((i) => i.value === v)?.label || v || "";
}

export function indicationShort(v) {
  return INDICATIONS.find((i) => i.value === v)?.short || v || "";
}
